function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.283 0a1 1 0 01.7.309l5.048 5.276L18.569.278a1 1 0 011.415.03l5.047 5.277L30.569.278a1 1 0 011.415.03l5.739 6a1 1 0 11-1.446 1.383L31.23 2.415l-5.538 5.307a1 1 0 01-1.415-.03L19.23 2.414l-5.538 5.307a1 1 0 01-1.415-.03L7.23 2.414 1.692 7.722A1 1 0 01.308 6.278l6.261-6A1 1 0 017.283 0z",
  fill: "#FFD500"
});

function SvgStrokeinline(props) {
  return React.createElement("svg", _extends({
    width: 38,
    height: 8,
    viewBox: "0 0 38 8",
    fill: "none"
  }, props), _ref);
}

export default SvgStrokeinline;